import { HTTPClient } from "./Client";

const AvisoApi = {

    async ListarAvisosComPaginacaoAsync(pagina, titulo, descricao) {
        const payload = {
            Pagina: pagina,
            Titulo: titulo,
            Descricao: descricao
        };

        const response = await HTTPClient.post(
            `/Aviso/ObterTodosAvisosPaginacao`,
            payload
        );

        return response.data;
    },

    async RemoverAvisoAsync(avisoId) {
        await HTTPClient.put(`/Aviso/DesativarAviso/${avisoId}`);
    },

    async VisualizarAvisoAsync(avisoId) {
        const response = await HTTPClient.get(
            `/Aviso/ObterInformacoesPorAvisoId/${avisoId}`
        );

        return response.data;
    },

    async CriarAvisoAsync(titulo, descricao, tipoAvisoEnum, usuariosId) {
        const payload = {
            Titulo: titulo,
            Descricao: descricao,
            TipoAvisoEnum: tipoAvisoEnum,
            UsuariosId: usuariosId && usuariosId.length > 0 ? usuariosId : []
        };

        await HTTPClient.post(`/Aviso/AdicionarAviso`, payload);
    }
};

export default AvisoApi;
